import { useEffect, useState, useCallback } from "react";
import { useQuery } from "react-query";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getDetailContent, IDetail } from "../../../api/api";
import { redirectURL } from "../../../utils/CommonFunc";
import { IMAGE_DNS } from "../../../utils/config/Config";
import CommonInput from "../Page/pageRight/CommonInput/CommonInput";
import Reply from "../Page/pageRight/Reply/Reply";
import Social from "../Page/pageRight/Social/Social";
import "./DetailPage.scoped.scss";
import { useRecoilValue } from "recoil";
import {
  isPrivacyAgreeState,
  isThroughMainState,
  naverAuthorizeUrl,
  userInfoState
} from "../../../atoms/atom";
import DetailLoading from "../../common/loading/DetailLoading";
import { useTranslation } from "react-i18next";
import IsMyArticle from "../common/isMyarticle/IsMyArticle";
import ContentsTags from "../common/ContentsTags";
import { PhotoAlbum } from "react-photo-album";
import { isLauncherState, loginState } from "../../../atoms/userInfoAtom";

function DetailPage() {
  const { t } = useTranslation();
  const { service_code, title, idx } = useParams();
  const userInfo = useRecoilValue(userInfoState);
  const navigate = useNavigate();
  const isLogin = useRecoilValue(loginState);
  const [loading, setLoading] = useState(true);
  const isThroughMain = useRecoilValue(isThroughMainState);
  const isPrivacyAgree = useRecoilValue(isPrivacyAgreeState);
  const naverAuthorize = useRecoilValue(naverAuthorizeUrl);
  const isLauncher = useRecoilValue(isLauncherState);

  const { isLoading, data } = useQuery<IDetail>(["detailContent"], () =>
    getDetailContent(
      service_code || "",
      title || "",
      idx || "",
      userInfo.Ssoinfo,
      userInfo.Userid,
      userInfo.Userbirth,
      userInfo.channelingType
    )
  );

  useEffect(() => {
    const timeout = setTimeout(() => setLoading((loading) => !loading), 1000);
    return () => clearTimeout(timeout);
  }, [setLoading]);

  const goLounge = useCallback(() => {
    if (isThroughMain === true) {
      navigate(-1);
    } else {
      redirectURL(
        `${window.location.origin}/page/${service_code}`,
        "_self",
        isLauncher
      );
    }
  }, [isThroughMain]);

  const min = 128;
  const max = 640;
  const randomHeight = Math.floor(Math.random() * (max - min + 1)) + min;

  const breakpoints = [1080, 640, 384, 256, 128, 96, 64, 48];

  const photos = (imgs: any) => {
    const data = imgs.map((photo: string) => ({
      src: photo,
      width: 1080,
      height: 800,
      srcSet: breakpoints.map((breakpoint) => {
        const height = randomHeight;
        return {
          src: photo,
          width: breakpoint,
          height
        };
      })
    }));

    return data;
  };

  return (
    <div className="layer-wrap article-type" id="DetailPage">
      <div
        className="shadow"
        onClick={() => {
          navigate(`/page/${service_code}`);
        }}
      />
      <div className="pop-layer">
        {/* 헤더 */}
        <h1 className="clearfix popUp-top">
          {t("view_post")}
          <Link className="btn-layer-close" to="#" onClick={goLounge}>
            <img
              src={
                IMAGE_DNS +
                "/Valofe_file/web/vfun-ko/images/common/icon/icon-page-pop-close-btn.png"
              }
              alt="글쓰기 팝업 창 닫기"
            />
          </Link>
        </h1>

        {isLoading ? (
          <DetailLoading />
        ) : data?.result === 1 ? (
          loading ? (
            <DetailLoading />
          ) : (
            <div className="pop-container animationOn">
              <h2 className="skip">VFUN 게시물</h2>
              <div className="frame">
                {/* 사용자 정보 */}

                <div className="info clearfix">
                  <img
                    className="user-pic"
                    src={
                      data.data.admin_icon !== ""
                        ? data.data.admin_icon
                        : IMAGE_DNS +
                          "/Valofe_file/web/vfun-ko/images/common/img-user-default-min.png"
                    }
                    alt="프로필 - 디폴트"
                  />
                  <IsMyArticle
                    user_id={data?.data.user_id}
                    idx={data.data.idx}
                    nickname={data?.data.nickname}
                  />
                  <div className="info-writing f-right icon-clock">
                    <img
                      className="icon-clock"
                      src={
                        IMAGE_DNS +
                        "/Valofe_file/web/vfun/images/common/icon/icon-clock-min.png"
                      }
                      alt="게시글 등록 시간"
                    />
                    {data?.data.created_at}
                  </div>
                </div>

                {/* 내용 */}
                <ContentsTags
                  data={data?.data.title}
                  className="detailTxt title"
                  admin={data.data.admin_flag}
                />
                <ContentsTags
                  data={data?.data.content}
                  className="detailTxt text"
                  admin={data.data.admin_flag}
                  type="detail"
                />
                {data?.data.images !== null &&
                data?.data.images.length !== 0 ? (
                  <div
                    className={`detailTxt ${
                      data?.data.images.length === 1 ? "img-ea-1" : ""
                    }`}
                  >
                    <PhotoAlbum
                      photos={photos(data.data.images)}
                      layout="rows"
                    />
                  </div>
                ) : null}
              </div>
              {/* 좋아요 */}
              <Social
                likeCount={data?.data.like_count}
                commentCount={data?.data.comments_count}
                idx={data.data.idx}
                userLike={data.data.user_like_status}
              />
              {/* 댓글 */}
              <CommonInput
                type={
                  isLogin
                    ? isPrivacyAgree
                      ? "reply"
                      : "privacyAgree"
                    : "login"
                }
              />
              <Reply />
            </div>
          )
        ) : (
          navigate(`all`, { replace: true })
        )}
      </div>
    </div>
  );
}

export default DetailPage;
